import React, {Component} from 'react';
import * as Yup from 'yup';
import GeneralFormComponent from '../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import {FormField} from '../../components/GeneralCRUDComponent/FormFields/formFields';
import {RouteComponentProps} from "react-router";
import {inject, observer} from "mobx-react";
import {Button, Typography} from "@material-ui/core";
import {IDealsStore} from "../../mobx-store/storeInterfaces/dealsStoreInterface";
import AlertDialog from "../../components/Dialog/alertDialog";


interface IProps {
    dealsStore: IDealsStore;
}

interface IState {
    formFields: FormField[];
    processing: boolean;
    loading: boolean;
    isDialogOpen: boolean;
}

@inject('dealsStore')
@observer
class AddEditDeals extends Component<IProps & RouteComponentProps<{
    dealId: string
}>, IState> {
    isNew: boolean = false;
    submitButton: any;
    cancelButton: any;
    TeamSchema: any;
    dealId: any;
    pageTitle = '';

    constructor(props: IProps & RouteComponentProps<{
        dealId: string
    }>) {
        super(props);
        if (this.props.match.params.dealId) {
            this.isNew = false;
            this.dealId = this.props.match.params.dealId;
            this.pageTitle = 'Edit Deal';
        } else {
            this.isNew = true;
            this.pageTitle = 'Add Deal';
        }
        this.initTeamSchema();
        this.initState();
        this.submitButton = this.getSubmitButton();
        this.cancelButton = this.getCancelButton();
    }

    initTeamSchema = () => {
        this.TeamSchema = Yup.object().shape({
            name: Yup.string().required('Required'),
            image: Yup.array()
                .min(1, 'You need to Add at Least one image')
                .max(1, 'You only need to Add one Image')
                .required('Required'),
        });
    };

    getSubmitButton = () => {
        return {
            title: (this.isNew ? 'Add' : 'Save Changes'),
            onSubmit: this.handelSubmit,
        };
    };

    getCancelButton = () => {
        return {
            title: 'Cancel',
            onCancel: this.navigateBack,
        };
    };

    navigateBack = () => {
        this.props.history.goBack();
    };

    handelSubmit = async (values: any) => {
        this.setState({processing: true});
        if (this.isNew) {
            await this.props.dealsStore.addDeal(values);
        } else {
            await this.props.dealsStore.editDeal(this.dealId, values);
        }
        this.navigateBack();
        this.setState({processing: false});
    };
    initState = () => {
        this.state = {
            isDialogOpen: false,
            processing: false,
            loading: false,
            formFields: [
                {
                    name: 'name',
                    label: 'Deal Name',
                    type: 'text',
                    filedType: 'InputField',
                },
                {
                    name: 'image',
                    label: 'Deal Image',
                    type: 'text',
                    filedType: 'GalleryField',
                    value: [],
                    accept: 'png',
                    isLimitToOneImage: true,
                },
                {
                    name: 'item',
                    label: 'Item',
                    selectListKey: 'itemId',
                    selectListValue: 'name',
                    filedType: 'DropdownField',
                },
                {
                    name: 'category',
                    label: 'Category',
                    selectListKey: 'categoryId',
                    selectListValue: 'categoryName',
                    filedType: 'DropdownField',
                },
                {
                    name: 'discount',
                    label: 'Discount',
                    type: 'number',
                    filedType: 'InputField',
                },
            ]
        };
    };
    updateStateWithTeamData = (currentCategory: any) => {
        const formFieldsWithData = [];
        for (let field of this.state.formFields) {
            if (field.name === 'image') {
                currentCategory[field.name] = [{imageUrl: currentCategory[field.name]}];
            }
            formFieldsWithData.push(Object.assign({}, field, {value: currentCategory[field.name]}));
        }
        this.setState({formFields: formFieldsWithData, processing: false, loading: false});
    };

    async componentDidMount() {
        this.props.dealsStore.getDeals();
        if (!this.isNew) {
            this.setState({loading: true});
            await this.props.dealsStore.getDealById(this.dealId).then(snapshot => {
                this.updateStateWithTeamData(snapshot.val());
            }).catch(() => {
                this.setState({loading: false});
            });

        }
    }

    handleDelete = async () => {
        this.setState({isDialogOpen: true});
    };
    handleAgree = async () => {
        await this.props.dealsStore.deleteDeal(this.dealId);
        this.navigateBack();
    };
    handleClose = () => {
        this.setState({isDialogOpen: false});
    };

    render() {
        const {loaded, items, categories} = this.props.dealsStore;
        if (loaded) {
            const formFields = this.state.formFields.map(field => {
                if (field.name === 'item') {
                    return {...field, selectList: items}
                } else if (field.name === 'category') {
                    return {...field, selectList: categories}
                } else {
                    return field;
                }
            });
            return (
                <div>
                    {this.state.loading ?
                        <Typography variant='h6' gutterBottom>Loading</Typography>
                        : <GeneralFormComponent
                            formTitle={this.pageTitle}
                            fields={formFields}
                            isDeal={true}
                            formSchema={this.TeamSchema}
                            submitButton={this.submitButton}
                            cancelButton={this.cancelButton}
                            processing={this.state.processing}
                        />
                    }
                    {
                        this.isNew ? null : <Button
                            onClick={this.handleDelete}
                            variant='contained'
                            type='button'
                            style={{fontSize: '14px', fontWeight: 'bold'}}
                            color='secondary'>
                            Delete
                        </Button>
                    }
                    {
                        <AlertDialog isOpen={this.state.isDialogOpen}
                                     title='Delete Category'
                                     content='Are You Sure You want to Delete This Deal?'
                                     buttonText='ok'
                                     agree={this.handleAgree}
                                     disAgree={this.handleClose}
                                     hasActions={true}
                        />
                    }
                </div>
            );
        } else
            return null;
    }
}

export default AddEditDeals;